import { c as _c } from "react/compiler-runtime";
import { classNames } from "@opensea/ui-kit";
import { topStickyVariants } from "@/styles/utils/sticky";
import { CurrencyStatsTableSkeleton } from "../CurrencyStatsTable/CurrencyStatsTableSkeleton";
export function ProfileCurrencyStatsTableSkeleton(t0) {
  const $ = _c(5);
  const {
    persona,
    headerClassName
  } = t0;
  let t1;
  if ($[0] !== headerClassName) {
    t1 = classNames(topStickyVariants({
      variant: "after-filter-toolbar",
      tableHeader: true
    }), headerClassName);
    $[0] = headerClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== persona || $[3] !== t1) {
    t2 = <CurrencyStatsTableSkeleton headerClassName={t1} persona={persona} profile={true} />;
    $[2] = persona;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}